angular.module('swapick')
.controller('ObjectCtrl', ObjectCtrl);


function ObjectCtrl($scope, $http, DataService, $stateParams, $timeout,
    Entities, Categories, initialLoaderManager, ObjectsService, $rootScope,
    $ionicModal, $ionicPopup, $cordovaCamera, $q, $ionicLoading, Enums) {

    $scope.vm = this;
    this.obj =  null;
    this.images = [];
    this.isCordova = !!window.cordova;
    this.numSwappables = null;
    this.conditionValues = [];
    this.ownedObjectData = {};
    this.objectPasssed = $stateParams.objFromList && $stateParams.objFromList.id === $stateParams.objectId;

    this.ownerId = $stateParams.userId;
    this.objectOwner = null;

    this.currentServices = {};
    this.currentPackages = {};
    this.noServices = false;

    this.loader = initialLoaderManager.makeLoader(()=>{

        return Categories
        .getCategories()
        .then(categories => {
          this.categoriesData = Categories.data;
          return Entities.waitForUser()
          .then((u)=>{
            this.user = u;
            //console.info("objFromList", $stateParams.objFromList)
            return this.getObject($stateParams.userId);
          })
        })
        .then(o => {
          this.conditionValues = Enums.getConditionsOptions(o.categoria.id);
          return DataService.services.getList()
          .then(services => {
            this.services = _.filter(services, i => i.tipo && i.soggetto=='item');
            return services
          })
        })
        .then(services => {
          return DataService.packages.getList()
          .then(packages => {
            this.packages = packages;
            return packages;
          })
        })

    }, false);


    let processObject = (resp) => {
      let obj = resp;
      this.obj = obj;
      this.images = [obj.immagine]
      this.images = this.images.concat(_.map(obj.altre_immagini, 'percorso'));
      this.isWanted = resp.voluto || $stateParams.wanted || false;
      this.isOwned = $stateParams.userId
        ? $stateParams.userId == this.user.id
        : _.find(obj.posseduto_da, (x)=> {
          return x.user.id == this.user.id;
        });

      try{
          let cat = this.categoriesData.categoriesById[obj.categoria.id][0]
          this.objAttributes = this.calculateAttributes(obj, cat)
      } catch(Err){
          console.error("Category %s not found in categories", obj.categoria.id);
          this.objAttributes = []
      }

      return obj;
    }


    this.getObjectWrapped = () => {
      let o = $q.defer();
      if($stateParams.objFromList){
          let obj = processObject($stateParams.objFromList);
          o.resolve(obj);
      } else {

        DataService
        .items
        .one($stateParams.objectId)
        .get({
          //user_id:$stateParams.userId
        })
        .then(resp => {
            let obj = processObject(resp);
            o.resolve(obj);
        })
        .catch(err => {
          o.reject(err);
        })
      }
      return o.promise;

    }


    this.getObject = (user_id) => {

        return this.getObjectWrapped()
        .then(obj => {

          if(!user_id || user_id==this.user.id){
            this.objectOwner = this.user;
            return obj;
          }

          let owner = _.find(obj.posseduto_da, i =>  i.user.id === parseInt(user_id))
          this.objectOwner = owner.user;

          //we don't wait for this, we can render ui meanwhile...
          DataService.itemsIcanGet
          .get({ swapper_id:user_id })
          .then(itemsIcan => {
            this.numSwappables = itemsIcan.total_items;
          })

          //check lo possiedo
          if(!this.objectPasssed){
            DataService.items
            .one(obj.id)
            .get({ user_id:this.user.id})
            .then(resp => {
              this.isOwned = true;
            })
            .catch(err => {

            })

          }

          return obj;
        })

    }

    $scope.$on('$ionicView.beforeEnter', () => {
      if(!this.obj){
        this.loader.load();
      }
    });


    this.calculateAttributes = (obj, category) => {

        var attrsByDescrizione = _.keyBy(_.sortBy(category.attributi, 'position'), 'descrizione');
        return  _.map(obj.attributi, attr=>{
            return { valore : attr.valore, descrizione : attr.descrizione, attr:attrsByDescrizione[attr.descrizione]}
        })
    }


    this.openAmazon = (link) => {
        window.open(link, "_system");
    }

    this.showConditionLabel = (conditionValue) => {
      let out = _.find(this.conditionValues, (i)=>i.value==conditionValue);
      if(!out){ return }
      return out.label;
    }


    this.saveOwned = () => {
      DataService.owned
      .post({
        id:this.obj.id,
        condizioni:this.ownedObjectData.condizioni.value,
        valore:this.ownedObjectData.valore,
        descrizione: this.ownedObjectData.descrizione,
        immagini_aggiuntive:this.ownedObjectData.immagini_aggiuntive
      })
      .then(resp => {
        this.isOwned = true;
        this.modal.hide();
      })

    }

    this.toggleOwned = () => {
        if(this.isOwned){
          var confirmPopup = $ionicPopup.confirm({
            title: 'Rimozione oggetto',
            template: 'Confermi di non possedere più questo oggetto?'
          });

          confirmPopup.then((res) => {
            if(res) {
               DataService.owned
              .one(this.obj.id.toString())
              .remove()
              .then(resp=>{
                this.isOwned = false;
              })
            } else {
               console.log('You are not sure');
            }
          });
        } else {
            this.ownedObjectData = { immagini_aggiuntive : []};
            this.modal.show();
        }
    }

    this.toggleWanted = () => {
        if(this.isWanted){
            this.isWanted = false;
            DataService.wanted
            .one(this.obj.id.toString())
            .remove()
            .catch(err => {
                this.isWanted = true;
            })
        } else {
            this.isWanted = true;
            DataService.wanted
            .post({id:this.obj.id})
            .catch(err => {
                this.isWanted = false;
            })
        }

    }

    this.imageChange = (img) => {
      $timeout(()=>{
        this.ownedObjectData.immagini_aggiuntive.push({image:img,id:_.uniqueId('img-')});
      })
    }

    this.dropImage = (idx) =>{
     $timeout(()=>{
        this.ownedObjectData.immagini_aggiuntive.splice(idx, 1);
      })
    }

    this.getCameraImage = (source="CAMERA")=>{
      document.addEventListener("deviceready",  () => {

      var options = {
        quality: 80,
        destinationType: Camera.DestinationType.DATA_URL,
        sourceType: Camera.PictureSourceType[source],
        allowEdit: true,
        encodingType: Camera.EncodingType.JPEG,
        //targetWidth: 100,
        //targetHeight: 100,
        popoverOptions: CameraPopoverOptions,
        saveToPhotoAlbum: false,
        correctOrientation:true
      };

      $cordovaCamera.getPicture(options).then((imageData) => {
        if(!imageData){
          return;
        }

        this.ownedObjectData.immagini_aggiuntive.push({image:"data:image/jpeg;base64," + imageData, id:_.uniqueId()});

        return imageData;

      }, err => {
        console.error(err);
      });

      }, false);

    }

    this.shopServices = () => {
      console.info("shopServices", this.currentServices, this.obj.id);
      return ObjectsService.shopServices(
        ObjectsService.prepareServices(this.currentServices, this.obj.id),
        this.currentPackages);
      }

    this.getAdditionalServices = () => {
      if(!this.servicesModal){ return }
      //updating ecoins
      return DataService.ecoins
      .get()
      .then(resp => {
        $rootScope.globals.userEcoins = parseInt(resp);
        return this.servicesModal.show();
      })

    }

    this.validServices = () => {
      return this.noServices || _.keys(this.currentServices).length || _.keys(this.currentPackages).length;
    }

    this.enoughEcoins = ObjectsService.enoughEcoins;

    this.checkResetServices = () => {
      if(!this.noServices){ return }
      this.currentServices = {};
      this.currentPackages = {};
    }

    //#TODO: same code in NewObjectCtrl
    this.checkResetNoServices = (item) => {
      this.noServices = false;
      let chiave = item.tipo ? item.tipo.chiave : null;
      _.each(this.services, (v) => {
        //reset all services with different key
        if((v.id && v.id != item.id && chiave && v.tipo.chiave === chiave)){
          this.currentServices[v.id] = false;
        }
      });

      _.each(this.packages, (v) => {
        //resets all packages
        if(v.id != item.id){
          this.currentServices[v.id] = false;
        }
      });

      //packages. Resetting all services.
      if(!item.tipo && item.servizi && item.servizi.length){
        _.each(this.services, (v) => {
          if(v.id != item.id && v.tipo){
            this.currentServices[v.id] = false;
          }
        });
      }

    }

    this.buyServices = () => {
      $ionicLoading.show();
      return this.shopServices()
      .then(()=>{
          return this.servicesModal.hide();
      })
      .catch(err=>{
        return console.error("error in shopping", err)
      })
      .finally(() => {
        $ionicLoading.hide();
      })
    }


    this.checkIsMine = () => this.user && parseInt(this.ownerId) == parseInt(this.user.id)

    //modal helpers
    $ionicModal.fromTemplateUrl("templates/own_modal.html", {
      scope:$scope
    }).then(modal => {
      this.modal = modal;
    })

    $ionicModal.fromTemplateUrl('templates/object-services-modal-simpler.html', {
      scope: $scope
    }).then(modal => {
      this.servicesModal = modal;
    });

    $ionicModal.fromTemplateUrl('templates/ecoin-buy-modal.html', {
      scope: $scope
    }).then(modal => {
      this.ecoinModal = modal;
    });



    $scope.$on('$destroy', () => {
      this.modal.remove();
      this.servicesModal.remove();
      this.ecoinModal.remove();
    });



}



// WEBPACK FOOTER //
// ./src/controllers/object-controller.js